import {
  Component,
  HostListener,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, Subscription } from 'rxjs';
import {
  isLargeScreen,
  isLargeScreenFun,
  sortArrayOfObject,
  updateCustomTableHeaders,
} from '../../../../global.variable';
import { AppService } from '../../../app.service';
import { UserProfileService } from '../../../profile/user-profile/user-profile.service';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { OrientationLockService } from '../../../shared/services/orientationlock.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { WebSocketService } from '../../../shared/services/web-socket.service';
import { ClientsService } from '../clients/clients.service';
import { JobsService } from '../jobs/jobs.service';
import { AddEditUserComponent } from './add-edit-user/add-edit-user.component';
import { UsersService } from './users.service';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'gtapp-users',
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss',
  standalone: false,
})
export class UsersComponent implements OnInit {
  userSearchString: string = '';

  previousUsers: number = 0;
  rowsUsers: number = 10;
  pageNumUsers: number = 1;
  totalPagesUsers: number = 0;
  allotedUserCount: number = 0;
  sortKeyUsers: any;
  searchParamsUsers: any;

  userPaginationData: any = {};
  subContractorDataDict: any = {};
  primeContractorUserDataDict: any = {};
  userDropDownList: any = [];

  totalUserCount: number = 0;
  reservedUserCount: number = 0;
  permanentUserCount: number = 0;

  toggleName: boolean = false;

  perDayPerUserPrice: number = 0;

  otherParamsUsers: any = {
    apiFiltering: true,
    tableRowStyle: (rowData: any) => {
      if (!rowData?.is_active) {
        return {
          opacity: '0.3',
        };
      }

      return {};
    },
  };

  userDetailsTableView: any = [];
  tableStyle = {
    'overflow': 'auto',
    'max-height': 'calc(100vh - 410px)',
  };

  dialogref: any;

  isSubscriberAdmin: boolean = false;
  isFreeAccessAccount: boolean = this.dataCheckService.isFreeAccessAccount();
  tabsUsers = {
    tab1: 'USERS',
    tab2: 'COMPLIANCES',
    tab3: 'DISPATCHER ACCESS',
  };
  selectedTab: string = this.tabsUsers.tab1;

  largeView: Boolean = isLargeScreen;
  isLargeScreenSubscription: Subscription = new Subscription();
  webSocketSubscription: any;

  selectedUser: any = {};

  // https://app.shortcut.com/sendem/story/12023/group-based-access-control-for-dispatchers
  groupListData: any = [];
  permissionListData: any = [];
  selectedPermissions = { old: new Set(), new: new Set(), same: true };
  dispatcherGroupData: any = {};

  userSlotAdded: boolean = false;

  accessStatusFilter: number = 0;

  userListFilterId: string = '';

  availableJobTypes: any = [];

  isNativeApp = Capacitor.isNativePlatform();

  constructor(
    private route: ActivatedRoute,
    private userService: UsersService,
    private dialogService: ModalDialogueService,
    private router: Router,
    private appService: AppService,
    private spinnerService: LoadingSpinnerService,
    private dataCheckService: DataCheckService,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
    private orientationService: OrientationLockService,
    private webSocketService: WebSocketService,
    private profileService: UserProfileService,
    private clientService: ClientsService,
    private jobService: JobsService,
  ) {
    this.userSlotAdded = this.route.snapshot.fragment === 'userAdded';

    // WHEN USER CLICK THE BACK BUTTON
    this.formatRouteUrl();
    this.getTableDetails();

    this.isSubscriberAdmin = this.dataCheckService.isSubscriberAdmin();
    this.webSocketSubscription =
      this.webSocketService.webSocketSubject.subscribe((event: any) => {
        if (
          ['wsn_user_registered'].includes(event?.event) &&
          this.selectedTab == this.tabsUsers.tab1
        ) {
          this.userPaginationData = {};
          this.spinnerService.show();
          setTimeout(() => {
            this.getUserListData();
          }, 200);
        }
      });
  }
  ngOnDestroy() {
    this.isLargeScreenSubscription?.unsubscribe();
  }
  ngOnInit(): void {
    this.getAllPossibleJobTypes(); // for user tag filters
    this.isLargeScreenSubscription =
      this.orientationService.isLargeScreen.subscribe(async (event: any) => {
        if (event) {
          this.largeView = await isLargeScreenFun();
        }
      });
    let userData = this.appService.getUserData();
    this.rowsUsers = Math.max(userData?.preferences?.user_page_size || 10, 10);
    const currentUrlPath: any = this.route.snapshot.url?.[0]?.path;
    if (currentUrlPath === 'credentials') {
      this.selectedTab = this.tabsUsers.tab2;
    } else {
      this.changeTab({ value: this.selectedTab });
    }
  }
  getAllPossibleJobTypes() {
    let subscriberStats = JSON.parse(
      localStorage.getItem('subscriberStats') || '{}',
    );

    this.jobService.getJobParams().subscribe((response: any) => {
      const filteredJobTypes = (response?.data || [])?.filter((_type: any) =>
        _type?.type_identity === 4
          ? subscriberStats.checkpoint_count > 0
          : true,
      );
      this.availableJobTypes = filteredJobTypes;
    });
  }

  onUserLookup(event: any) {
    if (event.target.value.length > 3) {
      this.userService
        .getUserListData({ search_str: event?.target.value })
        .subscribe((response: any) => {
          if (response['status'] == 'success') {
            this.userDropDownList = response?.data;
          }
        });
    }
  }
  getUserListData(getCount = true) {
    let params: any = {};
    if (this.rowsUsers) {
      params['rows'] = this.rowsUsers;
      let userData = this.appService.getUserData();
      if (userData?.preferences) {
        userData.preferences.user_page_size = this.rowsUsers;
        this.appService.setUserData(userData);
      }
    }

    if (this.previousUsers) {
      params['previous'] = this.previousUsers;
    }
    if (this.userSearchString) {
      params['search_str'] = this.userSearchString;
    }
    if (this.accessStatusFilter) {
      params['access_status'] = this.accessStatusFilter;
    }
    if (this.userListFilterId) {
      params['user_tag_id'] = this.userListFilterId;
    }

    if (this.searchParamsUsers) {
      Object.entries(this.searchParamsUsers).forEach(
        ([key, value]) => (params[key] = value),
      );
    }

    if (this.sortKeyUsers) {
      params['sort_key'] = this.sortKeyUsers;
    }
    if (this.toggleName) params['last_name_first'] = 1;
    if (this.userPaginationData?.[this.pageNumUsers]?.length) return;
    if (getCount) this.getUsersCount(params);

    this.spinnerService.show();
    this.userService.getUserListData(params).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.subContractorDataDict = {
          ...this.subContractorDataDict,
          ...response?.sub_contractor_dict,
        };
        this.primeContractorUserDataDict = {
          ...this.primeContractorUserDataDict,
          ...response?.prime_contractor_user_dict,
        };
        this.userPaginationData[this.pageNumUsers] = [...response?.data];

        if (this.userSlotAdded) {
          this.userSlotAdded = false;
          this.router.navigate(['/users']);
          this.openAddNewUserDialog();
        }
        this.updateRoutPath();

        this.spinnerService.hide();
      } else {
        this.spinnerService.hide();
      }
    });
  }

  async rowClick(event: any) {
    if (this.largeView) {
      if (this.selectedUser?.id == event?.id) return;

      this.selectedUser = {};
      setTimeout(() => {
        this.selectedUser = event;
      }, 100);
    } else {
      this.dialogref = this.dialogService.open(AddEditUserComponent, {
        data: {
          editUser: true,
          detailData: event,
          fromUserPage: true,
        },
      });
      const dResp = await firstValueFrom(this.dialogref.afterClosed());
      if (dResp == 'user-creds') {
        this.redirectToUserCreds();
        return;
      }
      this.userPaginationData = {};
      this.previousUsers = 0;
      this.pageNumUsers = 1;

      this.getUserListData();
    }
  }
  openAddNewUserDialog() {
    this.dialogref = this.dialogService.open(AddEditUserComponent, {
      data: {
        fromUserPage: true,
      },
    });
    this.dialogref.afterClosed().subscribe((value: any) => {
      if (value !== 'close') {
        this.previousUsers = 0;
        this.pageNumUsers = 1;
        this.userPaginationData = {};
        this.spinnerService.show();
        setTimeout(() => {
          this.getUserListData();
        }, 200);
      }
    });
  }

  openTemplate(template: TemplateRef<any>, eventData: any) {
    this.dialogref = this.dialogService.open(
      template,
      {
        data: eventData,
      },
      this.viewContainerRef,
    );
  }
  selectDropDown(event: any) {
    this.changeTab({ value: event.target.value });
  }

  changeTab(event: any) {
    this.selectedTab = event.value;
    const currentUrlPath: any = this.route.snapshot.url?.[0]?.path;

    if (currentUrlPath === 'credentials') {
      setTimeout(() => {
        // there is a home page redirection using /credentials which will releoad to that page even when tabs are switched. This will fix that issue.
        this.router.navigate(['/users'], { replaceUrl: true });
      }, 0);
    }
    switch (this.selectedTab) {
      case this.tabsUsers.tab1:
        this.getUserListData();
        break;
      case this.tabsUsers.tab3:
        this.tab3Selected();
        break;
    }

    this.updateRoutPath();
  }

  changePlan() {
    if (this.isSubscriberAdmin) {
      this.router.navigate(['/subscription'], {
        fragment: 'changePlan',
      });
    }
  }
  getUsersCount(reqParams: any) {
    let params: any = { get_count: 1, ...reqParams };

    this.userService.getUserListData(params).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.otherParamsUsers = {
          ...this.otherParamsUsers,
          paginationData: {
            totalRows: response?.total_size,
            previousRows: this.previousUsers,
            rows: this.rowsUsers,
            pageNum: this.pageNumUsers,
            totalPages: this.totalPagesUsers,
          },
        };

        this.totalUserCount = response?.total_user_count || 0;
        this.allotedUserCount = response?.allotted_slots || 0;
        this.reservedUserCount = response?.total_reserved_user_count || 0;
        this.permanentUserCount = response?.total_permanent_user_count || 0;
        this.perDayPerUserPrice = response?.per_day_per_guard_price || 0;

        if (this.accessStatusFilter === 2 && !this.reservedUserCount) {
          // updated/removed the last reserved user. IN that case switch and call the normal users
          this.accessStatusFilter = 1;
          this.userPaginationData = {};
          this.previousUsers = 0;
          this.pageNumUsers = 1;
          this.getUserListData();
        }
        if (this.totalUserCount > 1) {
          // for hiding and showing chat icon
          let subscriberStats = JSON.parse(
            localStorage.getItem('subscriberStats') || '{}',
          );
          subscriberStats.users_exist = true;
          localStorage.setItem(
            'subscriberStats',
            JSON.stringify(subscriberStats),
          );
        } else {
          let subscriberStats = JSON.parse(
            localStorage.getItem('subscriberStats') || '{}',
          );
          subscriberStats.users_exist = false;

          localStorage.setItem(
            'subscriberStats',
            JSON.stringify(subscriberStats),
          );
        }
      }
    });
  }
  updateRoutPath() {
    this.router.navigate([], {
      fragment: btoa(
        JSON.stringify({
          searchParams: this.searchParamsUsers,
          otherParams: this.otherParamsUsers,
          userSearchString: this.userSearchString,
          selectedTab: this.selectedTab,
          accessStatusFilter: this.accessStatusFilter,
          userListFilterId: this.userListFilterId,
        }),
      ),
      queryParams: {},
      replaceUrl: true,
    });
  }

  onChangePaginationUser(data: any) {
    this.previousUsers = data?.paginationData?.previousRows;
    this.pageNumUsers = data?.paginationData?.pageNum;
    if (data?.paginationData?.rows != this.rowsUsers) {
      this.userPaginationData = {};
    }
    this.rowsUsers = data?.paginationData?.rows;

    this.otherParamsUsers.paginationData = {
      ...data?.paginationData,
    };
    this.getUserListData(false);
  }
  sortColumnUser(body: any) {
    this.sortKeyUsers = body?.sortList || [];
    this.searchParamsUsers = body?.searchParams || {};
    this.userSearchString = '';
    this.userPaginationData = {};
    this.getUserListData(false);
  }
  searchColumnUser(event: any) {
    this.searchParamsUsers = event?.searchParams || {};
    this.clearValues();
    this.getUserListData();
  }
  clearValues() {
    this.previousUsers = 0;
    this.pageNumUsers = 1;
    this.userSearchString = '';
    this.userPaginationData = {};
  }
  formatRouteUrl() {
    if (!this.route.snapshot.fragment) return;
    try {
      const urlFragmentDetails = JSON.parse(atob(this.route.snapshot.fragment));

      if (urlFragmentDetails && Object.keys(urlFragmentDetails)?.length) {
        this.searchParamsUsers = {
          ...this.searchParamsUsers,
          ...(urlFragmentDetails?.searchParams || {}),
        };

        this.userSearchString = urlFragmentDetails?.userSearchString || '';
        this.userListFilterId = urlFragmentDetails?.userListFilterId || '';
        this.accessStatusFilter = urlFragmentDetails?.accessStatusFilter || 0;
        this.selectedTab =
          urlFragmentDetails?.selectedTab || this.tabsUsers.tab1;
        if (urlFragmentDetails?.otherParams?.paginationData) {
          this.previousUsers =
            urlFragmentDetails?.otherParams?.paginationData?.previousRows ||
            this.previousUsers;
          this.pageNumUsers =
            urlFragmentDetails?.otherParams?.paginationData?.pageNum ||
            this.pageNumUsers;
          this.rowsUsers =
            urlFragmentDetails?.otherParams?.paginationData?.rows ||
            this.rowsUsers;
        }
      }
    } catch (error) {}
  }
  getTableDetails() {
    let tableDetails = [
      {
        header: '',
        name: 'full_name',
        sortKey: 'full_name',
        toggleFields: true,
        sortOrder: 'asc',
        columnDataStyle: {
          'white-space': 'pre-line',
          'font-size': '18px',
        },

        conditionalColumnStyle: (row: any) => {
          if (this.primeContractorUserDataDict?.[row?.id]) {
            return {
              'white-space': 'pre-line',
              'background': '	#D1F2D1',
              'color': 'var(--bs-dark)',
            };
          } else {
            return {
              'white-space': 'pre-line',
            };
          }
        },

        prefixNestedValue: (row: any) => {
          if (row?.user_status == 'pending') {
            return `[USER HAS NEVER SIGNED-IN]\n`;
          }
          return '';
        },
        conditionalPrefixStyle: (row: any) => {
          if (row?.user_status == 'pending') {
            return {
              'color': 'var(--bs-purple)',
              'white-space': 'pre-line',
              'font-size': 'small',
              'float': 'right',
            };
          }

          return {};
        },

        suffixNestedValue: (row: any) => {
          let returnString = ``;
          if (this.primeContractorUserDataDict?.[row?.id]) {
            returnString = `\n ${row?.email} \n\n${this.primeContractorUserDataDict?.[row?.id]} \n Prime Contractor Login`;
          } else {
            let userGroups = [
              ...row?.['user_group']?.map((item: any) => {
                return item?.name;
              }),
            ].join(', ');

            returnString = `\n ${row?.email} \n\nGroups:  ${userGroups}`;
            const userTags: any = [
              ...row?.user_tags?.filter((item: any) => item),
            ];
            if (userTags?.length) {
              returnString += `\nTags: ${[
                ...userTags?.filter((item: any) => item),
              ].join(', ')}`;
            }
            if (this.subContractorDataDict?.[row?.id]) {
              returnString += `\n🟧 ${this.subContractorDataDict?.[row?.id]}`;
            }
          }

          return returnString;
        },
        suffixStyle: {
          'font-size': 'small',
        },
      },
      {
        // header: 'Status',
        iconObj: true,
        nestedValue: (row: any) => {
          if (!row?.is_active) return 'fa-solid fa-ban fa-2x text-danger';
          return row?.access_status === 1
            ? 'fa-solid fa-circle fa-2x text-success'
            : 'fa-regular fa-circle fa-2x text-body';
        },
        conditionalColumnStyle: (row: any) => {
          if (this.primeContractorUserDataDict?.[row?.id]) {
            return {
              'white-space': 'pre-line',
              'background': '	#D1F2D1',
              'color': 'var(--bs-dark)',
            };
          } else {
            return {
              'white-space': 'pre-line',
            };
          }
        },
      },
    ];

    updateCustomTableHeaders(tableDetails, this.searchParamsUsers);

    this.userDetailsTableView = [...tableDetails];
  }
  userUpdatedTriggered(event: any) {
    if (event == 'user-creds') {
      this.redirectToUserCreds();
      return;
    }
    if (event == 'deleted') {
      this.selectedUser = {};
    }

    this.subContractorDataDict = {};
    this.previousUsers = 0;
    this.pageNumUsers = 1;
    this.userPaginationData = {};
    this.getUserListData();
  }
  redirectToUserCreds() {
    sessionStorage.setItem(
      btoa('userDetailCredentialData'),
      JSON.stringify(this.selectedUser),
    );
    // this.changeTab({ value: this.tabsUsers.tab2 });
    this.router.navigate(['/credentials'], { fragment: 'active' });
  }
  getGroupListData() {
    return new Promise((resolve) => {
      this.profileService
        .fetchCompanyDetails({ group_permissions: 1 })
        .subscribe((response: any) => {
          this.groupListData = response?.data || [];

          this.dispatcherGroupData = this.groupListData?.find(
            (grp: any) => grp?.group_id == 3,
          );
          resolve(true);
        });
    });
  }

  async tab3Selected() {
    this.spinnerService.show();
    const result = await this.getGroupListData();
    this.jobService.getJobParams().subscribe((response: any) => {
      this.permissionListData = response?.data || [];
      this.checkForPermissionChanges();

      this.spinnerService.hide();
    });

    // https://app.shortcut.com/sendem/story/12023/group-based-access-control-for-dispatchers
    // currently doing only permissions for dispatchers and for job_types only
    // USER_GROUP_MANAGERS = 1, _("Managers")
    // USER_GROUP_GUARDS = 2, _("Guards")
    // USER_GROUP_DISPATCHERS = 3, _("Dispatchers")
    // USER_GROUP_ADMINISTRATOR = 4, _("Administrator")
  }
  updateJobTypePermission(itemData: any) {
    itemData.selected = !itemData?.selected;
    this.selectedPermissions['new'].clear();
    this.permissionListData?.forEach((jType: any) => {
      if (jType.selected) {
        this.selectedPermissions['new'].add(jType?.id);
      }
    });
    this.selectedPermissions['same'] =
      JSON.stringify([...this.selectedPermissions['new']]?.sort()) ===
      JSON.stringify([...this.selectedPermissions['old']]?.sort());
  }
  checkForPermissionChanges() {
    let jobTypePermisionsGiven = false;
    let dispatcherJobPermissions: any = [];
    if (this.dispatcherGroupData?.id) {
      jobTypePermisionsGiven = this.dispatcherGroupData?.permissions?.job_type;

      dispatcherJobPermissions =
        this.dispatcherGroupData?.permissions?.job_type || [];
    }
    this.selectedPermissions['new'].clear();
    this.selectedPermissions['old'].clear();
    this.selectedPermissions['same'] = true;
    this.permissionListData?.forEach((jType: any) => {
      jType.selected =
        !jobTypePermisionsGiven ||
        dispatcherJobPermissions?.some(
          (permission: any) =>
            permission?.id == jType?.id && permission?.permissions?.length,
        );
      if (jType.selected) {
        this.selectedPermissions['old'].add(jType?.id);
        this.selectedPermissions['new'].add(jType?.id);
        this.selectedPermissions['same'] = true;
      }
    });
    sortArrayOfObject(this.permissionListData, 'type_identity', 'asc');
  }
  updateGroupPermissions() {
    const updaterPermissionSettings = {
      ...(this.dispatcherGroupData?.permissions || {}),
    };
    const jobTypeSettings: any = [];
    this.permissionListData?.forEach((jType: any) => {
      if (jType?.selected) {
        jobTypeSettings.push({
          id: jType?.id,
          type_identity: jType?.type_identity,
          permissions: ['add', 'edit'],
        });
      }
    });
    updaterPermissionSettings['job_type'] = jobTypeSettings;
    this.spinnerService.show();
    this.clientService
      .updateCompanyDetails(
        {
          group_permissions: updaterPermissionSettings,
          group_id: this.dispatcherGroupData?.id,
        },
        { update_group_permission: 1 },
      )
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.toasterService.setMessage({
            successMessage: 'Permissions Updated',
            errorMessage: '',
          });
          this.spinnerService.hide();
          this.groupListData = response?.data || [];
          this.dispatcherGroupData = this.groupListData?.find(
            (grp: any) => grp?.group_id == 3,
          );
          this.checkForPermissionChanges();
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  async onUserListFilter(event: any) {
    this.userListFilterId = event.target.value;
    this.userPaginationData = {};
    this.previousUsers = 0;
    this.pageNumUsers = 1;
    this.getUserListData();
    this.selectedUser = {};
  }
}
